"use client";
import styled from "styled-components";
import {Col} from "react-bootstrap";
import React from "react";
import Title from "@/components/common/ui/Title";
import {hardGray, hover, softWhite, white} from "@/styles/globalStyleVars";
import reactHtmlParser from "react-html-parser";
import ThemeRow from "@/components/common/theme/row";
import CircleIcon from "@/components/common/ui/icons/CircleIcon";

 function WhyUs({data}) {


    return (
        <StyleComponent className="scroll-video pt-200 ">
            <p className="fixed-text parallax-xr">
                {reactHtmlParser(data?.section_data?.subtitle)}
            </p>

            <p className="fixed-text last parallax-x">
                {reactHtmlParser(data?.section_data?.search_slug)}
            </p>
            <div className="fixed-icon" data-speed={'1.2'}>
                <CircleIcon/>
            </div>
            <ThemeRow>
                <Col md={12} data-speed={'clamp(1.13)'}>
                    <Title type={'h4'} text={data?.section_data?.short_desc} margin={'0 0 80px 0'}/>
                </Col>
                <Col md={{offset: 3, span: 9}} data-speed={'clamp(1.25)'}>
                    {reactHtmlParser(data?.section_data?.description)}
                </Col>
            </ThemeRow>
        </StyleComponent>
    );
}
const StyleComponent = styled.section`
    background-color: ${white};
    position: relative;
    overflow: hidden;
    padding: 200px 0;

    .fixed-text {
        font-size: 240px;
        letter-spacing: 0.20px;
        line-height: 240px;
        color: ${softWhite};
        font-weight: 600;
        position: absolute;
        left: 0;
        top: 80px;
        &.last{
            left: 30%;
            top: 280px
        }
    }

    .fixed-icon {
        position: absolute;
        right: 0;
        top: 0;
    }
    ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        li {
            flex: 0 0 calc(50% - 30px);
            max-width: calc(50% - 30px);
            display: flex;
            gap: 30px;
            margin-bottom: 30px;

            b {
                font-size: 60px;
                line-height: 65px;
                color: ${hover};
                font-weight: 400;
            }

            h6 {
                margin-bottom: 20px;
            }

            p {
                font-size: 20px;
                line-height: 24px;
                color: ${hardGray};
                font-weight: 400;
            }
        }
    }
    
    @media(max-width: 992px){
        .col-md-9{
            margin: 0;
            max-width: 100% !important;
            flex: 0 0 100% !important;
        }
        ul{
            li{
                
            }
        }
    }
    
    @media(max-width: 767px){
        padding-top: 120px;
        padding-bottom: 90px;
        ul{
            flex-direction: column;
            li{
                flex: 0 0 calc(100% - 15px);
                max-width: calc(100% - 15px);
            }
        }
    }
`;

export default React.memo(WhyUs)